module.exports = __webpack_public_path__ + "static/media/Ravisara.2a177e00.jpeg";